import { requestType } from '~/config/enum.config';
var SERVICE = 'domain-service';
var CONTROLLER = 'productController';
export default {
    /**
     * 首页耐消下拉
     */
    selectProductList: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'selectProductList',
        type: requestType.Get
    }
};
